import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-code-type',
  template: `
    <label class="field-label">{{ props.label }}</label>
    <app-code-input-control
      [id]="idElement"
      [language]="props.codeType ?? 'HTML'"
      [placeholder]="props.placeholder ?? 'Digite o código aqui'"
      [height]="props.editorHeight ?? 320"
      [editorOptions]="props.editorOptions"
      [formControl]="formControl"
      [formlyAttributes]="field">
    </app-code-input-control>
  `,
  styleUrls: ['./formly-field-code-type.component.scss'],
  standalone: false
})
export class FormlyFieldCodeTypeComponent extends FieldType<FieldTypeConfig> {
  private static nextInstanceId = 0;
  private resolvedId?: string;

  get idElement(): string {
    if (this.resolvedId) {
      return this.resolvedId;
    }

    if (this.props?.id) {
      this.resolvedId = `codeInput${this.props.id}`;
      return this.resolvedId;
    }

    this.resolvedId = `codeInput-${++FormlyFieldCodeTypeComponent.nextInstanceId}`;
    return this.resolvedId;
  }
}
